<template>
  <div v-if="currentCommande">
    <div class="mt-4 mb-4">
      <div class="row">
        <div class="col-md-12 col-lg-6">
          <div class="table-rsesponsive" style="background: white">
            <table class="table table-detail">
              <tbody>
                <tr>
                  <td>
                    <i class="far fa-calendar text-custom-primary"></i>
                    <span class="font-weight-bold"> Date</span>
                  </td>
                  <td>{{ currentCommande.date }}</td>
                </tr>

                <tr>
                  <td>
                    <i class="fa fa-info-circle text-custom-primary"></i>
                    <span class="font-weight-bold"> Fournisseur</span>
                  </td>
                  <td>
                    {{ currentCommande.fournisseur.nom }}
                  </td>
                </tr>

                <tr>
                  <td>
                    <i class="fa fa-info-circle text-custom-primary"></i>
                    <span class="font-weight-bold"> Centre de coût</span>
                  </td>
                  <td>
                    {{ currentCommande.centre_cout.nom }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="mt-n4 mt-lg-0 col-md-12 col-lg-6">
          <div class="table-rsesponsive" style="background: white">
            <table class="table table-detail">
              <tbody>
                <tr>
                  <td>
                    <i class="far fa-calendar text-custom-primary"></i>
                    <span class="font-weight-bold">
                      Date de réception souhaitée</span
                    >
                  </td>
                  <td>{{ currentCommande.date_reception }}</td>
                </tr>

                <tr>
                  <td>
                    <i class="fa fa-info-circle text-custom-primary"></i>
                    <span class="font-weight-bold"> Devise</span>
                  </td>
                  <td>
                    {{
                      currentCommande.devise.symbole +
                      ' ( ' +
                      currentCommande.devise.nom +
                      ' )'
                    }}
                  </td>
                </tr>
                <tr>
                  <td>
                    <i class="far fa-user text-custom-primary"></i>
                    <span class="font-weight-bold"> Auteur</span>
                  </td>
                  <td class="text-primary">
                    {{
                      currentCommande.document.created_by.prenom
                        ? currentCommande.document.created_by.prenom +
                          ' ' +
                          currentCommande.document.created_by.nom
                        : currentCommande.document.created_by.nom
                    }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="row mt-n2">
        <div class="col-md-12">
          <table class="card table table-sm">
            <thead>
              <tr class="d-flex"></tr>
              <tr class="d-flex">
                <th class="col-4">Article</th>
                <th class="col-2 text-center">Quantité</th>
                <th class="col-1 text-center">Prix HT</th>
                <th class="col-1 text-center">TVA %</th>
                <th class="col-2 text-center">
                  Budget
                  <span v-if="getCurrency()">
                    ({{ getCurrency().symbole }})
                  </span>
                </th>
                <th class="col-2 text-center">Montant</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(item, index) in currentCommande.item_lists"
                :key="index"
                class="d-flex"
              >
                <td class="col-4" style="vertical-align: middle">
                  Désignation : {{ item.designation }} <br />
                  Référence : {{ item.reference }} <br />
                  Stock :
                  {{
                    item.stock !== '-'
                      ? item.stock + ' ' + item.unite
                      : item.stock
                  }}
                </td>

                <td class="col-2 text-center" style="vertical-align: middle">
                  {{ item.quantite + ' ' + item.unite }}
                </td>
                <td class="col-1 text-center" style="vertical-align: middle">
                  {{
                    formatWithCurrency(
                      item.prix,
                      currentCommande.devise.symbole
                    )
                  }}
                </td>

                <td class="col-1 text-center" style="vertical-align: middle">
                  {{ item.tva + ' %' }}
                </td>

                <td class="col-2 text-center" style="vertical-align: middle">
                  <progress-bar
                    v-if="item.etat !== null"
                    bar-color="#dc720f"
                    :val="item.consommation"
                    :max="100"
                    :text="item.etat"
                    size="medium"
                  />
                  <span v-else> ### </span>
                </td>
                <td
                  class="col-2 text-right font-weight-bold font-size-17"
                  style="vertical-align: middle"
                >
                  {{
                    formatWithCurrency(
                      item.quantite * item.prix +
                        (item.tva / 100) * (item.quantite * item.prix),
                      currentCommande.devise.symbole
                    )
                  }}
                </td>
              </tr>
              <tr v-if="currentCommande.item_lists.length === 0" class="d-flex">
                <td class="text-center col-12">Aucune donnée</td>
              </tr>
            </tbody>
            <tfoot class="font-weight-bold font-size-18">
              <tr class="d-flex">
                <td class="text-right col-8">TOTAL HT</td>
                <td class="text-right col-4">
                  {{
                    formatWithCurrency(totalHt, currentCommande.devise.symbole)
                  }}
                </td>
              </tr>
              <tr class="d-flex" v-if="totalTva > 0">
                <td class="text-right col-8">TOTAL TVA</td>
                <td class="text-right col-4">
                  {{
                    formatWithCurrency(totalTva, currentCommande.devise.symbole)
                  }}
                </td>
              </tr>
              <tr class="d-flex" v-if="totalTva > 0">
                <td class="text-right col-8">TOTAL TTC</td>
                <td class="text-right col-4">
                  {{
                    formatWithCurrency(
                      totalHt + totalTva,
                      currentCommande.devise.symbole
                    )
                  }}
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import URL from '@/http/achat/commande';
import ProgressBar from 'vue-simple-progress';
export default {
  data() {
    return {
      currentCommande: null,
    };
  },
  computed: {
    totalHt() {
      return window._.sumBy(
        this.currentCommande.item_lists,
        (item) => item.quantite * item.prix
      );
    },
    totalTva() {
      return window._.sumBy(
        this.currentCommande.item_lists,
        (item) => (item.tva / 100) * (item.quantite * item.prix)
      );
    },
  },
  components: {
    ProgressBar,
  },
  methods: {
    init() {
      window.axios
        .get(URL.COMMANDE + '/' + this.$route.params.id)
        .then((resp) => {
          this.currentCommande = resp.data.commande_achat;
          this.getBudgetArticles(
            this.currentCommande.item_lists,
            this.currentCommande.centre_cout.uuid,
            this.currentCommande.annee
          );
        })
        .catch();
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style scoped></style>
